<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent


style="margin-top: -30px!important;"

========================================================================================== -->

<template>
  <div
    id="dashboard-analytics"
    style="margin-top: -40px!important;"
    @paste="onPaste"
  >
    <!-- <vs-alert color="warning" :active.sync="showWarningMessage">
      <span>Você possui alterações de layout não atualizadas </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->
    <div
    >
    <!-- class="dashboard-container" -->
    <!-- :style="rowsCount <= 4 ? bodySize : bodySize" -->
      <vs-popup
        class="edit-dashboard-card"
        title="Editar Card"
        :active.sync="dashboardDataEdit.showEditDashboardCardModal"
      >
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="vs-input--label">Tipo do card:</label>
            <v-select
              :closeOnSelect="true"
              disabled
              label="name"
              v-model="dashboardDataEdit.cardType"
              :options="dashboardData.cardTypeOptions"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="w-full mt-4 mb-4"
              label="Nome"
              v-model="dashboardDataEdit.cardName"
              name="card-name"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <label for="card-description mt-4" class="vs-input--label"
              >Descrição</label
            >
            <vs-textarea
              class="w-full"
              v-model="dashboardDataEdit.cardDescription"
              name="card-description"
            />
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col">
            <label class="vs-input--label">Largura:</label>
            <vs-input-number
              min="200"
              max="1200"
              v-model="dashboardDataEdit.cardWidth"
            />
          </div>
          <div class="vx-col">
            <label class="vs-input--label">Altura:</label>
            <vs-input-number
              min="200"
              max="1200"
              v-model="dashboardDataEdit.cardHeight"
            />
          </div>
        </div>
        <br /><br /><br /><br />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-button class="ml-auto mt-2" @click="updateCard"
              >Salvar</vs-button
            >
          </div>
        </div>
      </vs-popup>

      <vue-context
        ref="menu"
        v-if="$store.state.dashboardAnalytics.viewMode === 'edit'"
      >
        <ul class="bordered-items p-0" slot-scope="item">
          <li>
            <a
              href="#"
              @click="getCardDetail(item.data)"
              class="flex items-center text-sm"
            >
              <feather-icon
                icon="Edit2Icon"
                svgClasses="w-5 h-5 text-primary"
              />
              <span class="ml-2">Editar</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              @click="confirmDeleteCard(item.data)"
              class="flex items-center text-sm"
            >
              <feather-icon icon="XIcon" svgClasses="w-5 h-5 text-danger" />
              <span class="ml-2">Excluir</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              @click="alignItem($event, item.data)"
              class="flex items-center text-sm"
            >
              <feather-icon icon="AlignCenterIcon" svgClasses="w-5 h-5" />
              <span class="ml-2">Alinhar Topo</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              @click="alignLeft($event, item.data)"
              class="flex items-center text-sm"
            >
              <feather-icon icon="AlignLeftIcon" svgClasses="w-5 h-5" />
              <span class="ml-2">Alinhar à Esquerda</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              @click="quickFormatItem($event, item.data)"
              class="flex items-center text-sm"
            >
              <feather-icon icon="PenToolIcon" svgClasses="w-5 h-5" />
              <span class="ml-2">Formatação Rápida</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              @click="onPaste($event, item.data)"
              class="flex items-center text-sm"
            >
              <feather-icon icon="CopyIcon" svgClasses="w-5 h-5" />
              <span class="ml-2">Duplicar</span>
            </a>
          </li>
        </ul>
      </vue-context>

      <div class="vx-row dash-row" v-if="canLoadData" :key="mainDivKey">
        <template v-for="card in $options.dashboardRows[0]">
          <!-- CARD 1: CONGRATS -->
          <!-- class-name="draggable-container dash-lg"  -->
          <!-- :class-name = "(windowSize > 1366 && card.x > 1485)?'draggable-container dash-lg offset':'draggable-container dash-lg'" -->
          <vue-draggable-resizable
            v-if="card.type_id === 1"
            preventActiveBehavior
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            :class-name="
              windowSize > 1366 && card.x > 1485
                ? 'draggable-container dash-lg'
                : 'draggable-container dash-lg'
            "
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :minWidth="655"
            :maxWidth="maxWidthCard > 0 ? maxWidthCard : 1200"
            :maxHeight="400"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
            :key="card.hash + Math.random()"
          >
            <div
              class="vx-col w-full lg:w-1/2 mb-base"
              @copy="onCopy"
              :data-hash="card.hash"
              @click="setZIndex(card.hash)"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <vx-card
                slot="no-body"
                class="text-center greet-user is-congrats"
              >
                <img
                  src="@/assets/images/elements/decore-left.png"
                  class="decore-left"
                  alt="Decore Left"
                  width="200"
                />
                <img
                  src="@/assets/images/elements/decore-right.png"
                  class="decore-right"
                  alt="Decore Right"
                  width="175"
                />
                <feather-icon
                  :icon="card.payload['icon']"
                  class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                  svgClasses="h-8 w-8"
                ></feather-icon>
                <h1
                  class="mb-6 text-white"
                  @blur="changeCardLabel($event, card.hash, 1)"
                  :contentEditable="
                    $store.state.dashboardAnalytics.viewMode === 'edit'
                      ? true
                      : false
                  "
                >
                  {{ card.payload["title"] }}
                  <!-- <input type="text" class="mb-6 text-white" name="card-name" style="background: linear-gradient(118deg, rgba(var(--vs-primary), 1), rgba(var(--vs-primary), 0.7)) !important;border: none;font-size: 28px!important;"> -->
                </h1>
                <p
                  class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white"
                  v-html="card.payload['subtitle']"
                ></p>
              </vx-card>
            </div>
          </vue-draggable-resizable>

          <!-- CARD 2: SUBSCRIBERS GAINED -->
          <!-- class-name="draggable-container stats-md" offset -->
          <!-- :x="card.x"  1769 -->
          <vue-draggable-resizable
            v-else-if="card.type_id === 2"
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            class-name="draggable-container stats-md"
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :minWidth="218"
            :maxWidth="maxWidthCard > 0 ? maxWidthCard : 700"
            :maxHeight="400"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
            :key="card.hash + Math.random()"
          >
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
              @copy="onCopy"
              @click="setZIndex(card.hash)"
              :data-hash="card.hash"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <statistics-card-line
                :icon="card.payload.icon"
                @blur="changeCardLabel($event, card.hash, 2)"
                :statistic="card.payload.analyticsData.subscribers"
                :statisticTitle="card.payload.title || 'Label'"
                :chartData="card.payload.series"
                type="area"
              ></statistics-card-line>
            </div>
          </vue-draggable-resizable>
        </template>

        <!-- CARD 3: ORDER RECIEVED -->
        <!-- <vue-draggable-resizable
          class-name="draggable-container stats-md"
          :scale="1" :x="970" :y="8"
          :maxWidth="700" :maxHeight="400"
          @dragging="dragPosition" @resizestop="resizePosition"
          >
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <statistics-card-line icon="ShoppingBagIcon" statistic="97.5K" statisticTitle="Orders Received" :chartData="ordersRecevied.series" color="warning" type="area"></statistics-card-line>
        </div>
        </vue-draggable-resizable> -->
      </div>

      <div class="vx-row dash-row">
        <template v-for="card in $options.dashboardRows[1]">
          <!-- CARD 3: SALES BAR -->
          <!-- class-name="draggable-container chart-mb-l"  offset-->
          <vue-draggable-resizable
            v-if="card.type_id === 3"
            preventActiveBehavior
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            :class-name="
              windowSize > 1366 && card.x > 1510
                ? 'draggable-container chart-mb-l'
                : 'draggable-container chart-mb-l'
            "
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :minWidth="601"
            :maxWidth="maxWidthCard > 0 ? maxWidthCard : 900"
            :maxHeight="500"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
            :key="card.hash + Math.random()"
          >
            <div
              class="vx-col w-full md:w-1/2 mb-base"
              @copy="onCopy"
              :data-hash="card.hash"
              @click="setZIndex(card.hash)"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <vx-card>
                <div
                  class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
                >
                  <!-- LEFT COL -->
                  <div
                    class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between"
                    v-if="card.payload.analyticsData"
                  >
                    <div>
                      <h2 class="mb-1 font-bold">
                        {{ card.payload.analyticsData.amount }}
                      </h2>
                      <span
                        class="font-medium"
                        @blur="changeCardLabel($event, card.hash, 3)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ card.payload.subtitle }}</span
                      >

                      <!-- Previous Data Comparison -->
                      <p class="mt-2 text-xl font-medium">
                        <span
                          :class="
                            'text-' +
                              card.payload.analyticsData.comparison.color
                          "
                        >
                          <span
                            >{{ card.payload.analyticsData.comparison.value }}
                          </span>
                        </span>
                        <span
                          @blur="changeCardLabel($event, card.hash, 4)"
                          :contentEditable="
                            $store.state.dashboardAnalytics.viewMode === 'edit'
                              ? true
                              : false
                          "
                          >{{ card.payload.analyticsData.comparison.str }}</span
                        >
                      </p>
                    </div>
                    <!-- -chevrons-right -->
                    <vs-button
                      icon-pack="feather"
                      :style="
                        $store.state.dashboardAnalytics.viewMode === 'edit'
                          ? { cursor: 'text' }
                          : { cursor: 'pointer' }
                      "
                      @click="viewDetailUrl(card.payload.viewDetailsButtonLink)"
                      icon-after
                      class="shadow-md w-full lg:mt-0 mt-4"
                      @blur="changeCardLabel($event, card.hash, 5)"
                      :contentEditable="
                        $store.state.dashboardAnalytics.viewMode === 'edit'
                          ? true
                          : false
                      "
                      >{{ card.payload.viewDetailsButtonLabel }}</vs-button
                    >
                  </div>

                  <!-- RIGHT COL -->
                  <div
                    class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base"
                  >
                    <!-- <change-time-duration-dropdown class="self-end" /> -->
                    <vue-apex-charts
                      type="bar"
                      :width="card.width / 2.1"
                      height="250"
                      :options="analyticsData.salesBar.chartOptions"
                      :series="card.payload.series"
                      v-if="card.payload.series"
                    />
                  </div>
                </div>
                <vs-divider class="my-6"></vs-divider>
                <div class="vx-row">
                  <div class="vx-col w-1/2 mb-3">
                    <p>
                      <span
                        @blur="changeCardLabel($event, card.hash, 6)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ card.payload.bottomInfoOne.title }} </span
                      ><span>{{ card.payload.bottomInfoOne.textValue }}</span>
                    </p>
                    <vs-progress
                      class="block mt-1"
                      :percent="card.payload.bottomInfoOne.value"
                      :color="card.payload.bottomInfoOne.color"
                    ></vs-progress>
                  </div>
                  <div class="vx-col w-1/2 mb-3">
                    <p>
                      <span
                        @blur="changeCardLabel($event, card.hash, 7)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ card.payload.bottomInfoTwo.title }} </span
                      ><span>{{ card.payload.bottomInfoTwo.textValue }}</span>
                    </p>
                    <vs-progress
                      class="block mt-1"
                      :percent="card.payload.bottomInfoTwo.value"
                      :color="card.payload.bottomInfoTwo.color"
                    ></vs-progress>
                  </div>
                  <div class="vx-col w-1/2 mb-3">
                    <p>
                      <span
                        @blur="changeCardLabel($event, card.hash, 8)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ card.payload.bottomInfoThree.title }} </span
                      ><span>{{ card.payload.bottomInfoThree.textValue }}</span>
                    </p>
                    <vs-progress
                      class="block mt-1"
                      :percent="card.payload.bottomInfoThree.value"
                      :color="card.payload.bottomInfoThree.color"
                    ></vs-progress>
                  </div>
                  <div class="vx-col w-1/2 mb-3">
                    <p>
                      <span
                        @blur="changeCardLabel($event, card.hash, 9)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ card.payload.bottomInfoFour.title }} </span
                      ><span>{{ card.payload.bottomInfoFour.textValue }}</span>
                    </p>
                    <vs-progress
                      class="block mt-1"
                      :percent="card.payload.bottomInfoFour.value"
                      :color="card.payload.bottomInfoFour.color"
                    ></vs-progress>
                  </div>
                </div>
              </vx-card>
            </div>
          </vue-draggable-resizable>

          <!-- CARD 4: SUPPORT TRACKER -->
          <!-- class-name="draggable-container chart-mb"  offset -->
          <vue-draggable-resizable
            preventActiveBehavior
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            v-else-if="card.type_id === 4"
            :class-name="
              windowSize > 1366 && card.x > 1510
                ? 'draggable-container chart-mb '
                : 'draggable-container chart-mb'
            "
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :maxWidth="maxWidthCard > 0 ? maxWidthCard : 900"
            :minWidth="373"
            :maxHeight="500"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
            :key="card.hash + Math.random()"
          >
            <div
              class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"
              @copy="onCopy"
              @click="setZIndex(card.hash)"
              :data-hash="card.hash"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <vx-card
                @blur="changeCardLabel($event, card.hash, 10)"
                :title="card.payload.title || 'Support Tracker'"
                :editTitle="
                  $store.state.dashboardAnalytics.viewMode === 'edit'
                    ? true
                    : false
                "
              >
                <!-- CARD ACTION -->
                <!-- <template slot="actions">
                    <change-time-duration-dropdown />
                </template> -->

                <div slot="no-body" v-if="card.payload.analyticsData">
                  <div class="vx-row text-center">
                    <!-- Open Tickets Heading -->
                    <div
                      class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last"
                    >
                      <div
                        class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6"
                      >
                        <h1 class="font-bold text-5xl">
                          {{ card.payload.analyticsData.total }}
                        </h1>
                        <small
                          @blur="changeCardLabel($event, card.hash, 11)"
                          :contentEditable="
                            $store.state.dashboardAnalytics.viewMode === 'edit'
                              ? true
                              : false
                          "
                          >{{ card.payload.analyticsData.totalInfo }}</small
                        >
                      </div>
                    </div>

                    <!-- Chart -->
                    <div
                      class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6"
                    >
                      <vue-apex-charts
                        type="radialBar"
                        height="385"
                        :options="card.payload.chartOptions"
                        :series="card.payload.series"
                      />
                    </div>
                  </div>

                  <!-- Support Tracker Meta Data -->
                  <div class="flex flex-row justify-between px-8 pb-4 mt-4">
                    <p
                      class="text-center"
                      v-for="(val, index) in card.payload.analyticsData.meta"
                      :key="index"
                    >
                      <span
                        class="block"
                        @blur="changeCardLabel($event, card.hash, index + 12)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ val["label"] }}</span
                      >
                      <span class="text-2xl font-semibold">{{
                        val["value"]
                      }}</span>
                    </p>
                  </div>
                </div>
              </vx-card>
            </div>
          </vue-draggable-resizable>
        </template>
      </div>

      <div class="vx-row dash-row">
        <template v-for="card in $options.dashboardRows[2]">
          <!-- CARD 5: Product Orders -->
          <!-- class-name="draggable-container chart-md" offset -->
          <vue-draggable-resizable
            preventActiveBehavior
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            v-if="card.type_id === 5"
            :class-name="
              windowSize > 1366 && card.x > 1510
                ? 'draggable-container chart-md '
                : 'draggable-container chart-md'
            "
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :maxWidth="maxWidthCard > 0 ? maxWidthCard : 700"
            :minWidth="375"
            :maxHeight="700"
            :key="card.hash + Math.random()"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
          >
            <div
              class="vx-col w-full lg:w-1/3 mb-base"
              @copy="onCopy"
              :data-hash="card.hash"
              @click="setZIndex(card.hash)"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <vx-card
                :title="card.payload.title"
                @blur="changeCardLabel($event, card.hash, 15)"
                :editTitle="
                  $store.state.dashboardAnalytics.viewMode === 'edit'
                    ? true
                    : false
                "
              >
                <!-- Chart -->
                <div slot="no-body">
                  <!-- <vue-apex-charts type="radialBar" height="420" :options="analyticsData.productOrdersRadialBar.chartOptions" :series="card.payload.series" /> -->
                  <vue-apex-charts
                    type="radialBar"
                    height="420"
                    :options="card.payload.chartOptions"
                    :series="card.payload.series"
                  />
                </div>
                <ul>
                  <li
                    v-for="(orderData, index) in card.payload.analyticsData"
                    :key="orderData.orderType"
                    class="flex mb-3 justify-between"
                  >
                    <span class="flex items-center">
                      <span
                        class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
                        :class="`border-${orderData.color}`"
                      ></span>
                      <span
                        class="font-semibold"
                        @blur="changeCardLabel($event, card.hash, 16, index)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ orderData.orderType }}</span
                      >
                    </span>
                    <span>{{ orderData.counts }}</span>
                  </li>
                </ul>
              </vx-card>
            </div>
          </vue-draggable-resizable>
          <!-- CARD 6 Sales Stats -->
          <!-- class-name="draggable-container chart-md" offset -->
          <vue-draggable-resizable
            preventActiveBehavior
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            v-else-if="card.type_id === 6"
            :class-name="
              windowSize > 1366 && card.x > 1510
                ? 'draggable-container chart-md '
                : 'draggable-container chart-md'
            "
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :minWidth="375"
            :maxWidth="maxWidthCard > 0 ? maxWidthCard : 700"
            :maxHeight="700"
            :key="card.hash + Math.random()"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
          >
            <div
              class="vx-col w-full lg:w-1/3 mb-base"
              @copy="onCopy"
              :data-hash="card.hash"
              @click="setZIndex(card.hash)"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <vx-card
                @blur="changeCardLabel($event, card.hash)"
                :title="card.payload.title"
                :subtitle="card.payload.subtitle"
                :editTitle="
                  $store.state.dashboardAnalytics.viewMode === 'edit'
                    ? true
                    : false
                "
                :editSubtitle="
                  $store.state.dashboardAnalytics.viewMode === 'edit'
                    ? true
                    : false
                "
              >
                <div class="flex">
                  <template v-for="(item, index) in card.payload.series">
                    <span
                      v-if="index === 0"
                      class="flex items-center"
                      :key="index"
                      ><div
                        class="h-3 w-3 rounded-full mr-1"
                        :style="{ backgroundColor: item.backgroundColor }"
                      ></div>
                      <span
                        @blur="changeCardLabel($event, card.hash, 19, index)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ item.name }}</span
                      ></span
                    >
                    <span v-else class="flex items-center ml-4" :key="index"
                      ><div
                        class="h-3 w-3 rounded-full mr-1"
                        :style="{ backgroundColor: item.backgroundColor }"
                      ></div>
                      <span
                        @blur="changeCardLabel($event, card.hash, 19, index)"
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        >{{ item.name }}</span
                      ></span
                    >
                  </template>
                  <!-- <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>Sales</span></span>
                    <span class="flex items-center ml-4"><div class="h-3 w-3 rounded-full mr-1 bg-success"></div><span>Visits</span></span> -->
                </div>
                <div slot="no-body-bottom">
                  <vue-apex-charts
                    type="radar"
                    height="385"
                    :options="card.payload.chartOptions"
                    :series="salesRadar.series"
                  />
                </div>
              </vx-card>
            </div>
          </vue-draggable-resizable>

          <!-- CARD 7: Activity Timeline -->
          <!-- class-name="draggable-container chart-md"  offset-->
          <vue-draggable-resizable
            preventActiveBehavior
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            v-else-if="card.type_id === 7"
            :class-name="
              windowSize > 1366 && card.x > 1510
                ? 'draggable-container chart-md '
                : 'draggable-container chart-md'
            "
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :key="card.hash + Math.random()"
            :minWidth="375"
            :maxWidth="maxWidthCard > 0 ? maxWidthCard : 700"
            :maxHeight="700"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
          >
            <div
              class="vx-col w-full lg:w-1/3 mb-base"
              @copy="onCopy"
              :data-hash="card.hash"
              @click="setZIndex(card.hash)"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <vx-card
                @blur="changeCardLabel($event, card.hash, 20)"
                :title="card.payload.title"
                :editTitle="
                  $store.state.dashboardAnalytics.viewMode === 'edit'
                    ? true
                    : false
                "
                :editSubtitle="
                  $store.state.dashboardAnalytics.viewMode === 'edit'
                    ? true
                    : false
                "
              >
                <vx-timeline :data="card.payload.data" />
              </vx-card>
            </div>
          </vue-draggable-resizable>
        </template>
      </div>

      <div class="vx-row dash-row">
        <template v-for="card in $options.dashboardRows[3]">
          <!-- CARD 8: DISPATCHED ORDERS -->
          <!-- class-name="draggable-container orders-lg"  offset-->
          <vue-draggable-resizable
            preventActiveBehavior
            :draggable="draggableAndResizable"
            :resizable="draggableAndResizable"
            v-if="card.type_id === 8"
            :class-name="
              windowSize > 1366 && card.x > 1510
                ? 'draggable-container orders-lg '
                : 'draggable-container orders-lg'
            "
            :scale="1"
            :x="card.x"
            :y="card.y"
            :w="card.width"
            :h="card.height"
            :minWidth="916"
            :maxWidth="5000"
            :max-height="400"
            @dragstop="dragPosition(card.hash, ...arguments)"
            @resizestop="resizePosition(card.hash, ...arguments)"
            :key="card.hash + Math.random()"
          >
            <div
              class="vx-col w-full"
              @copy="onCopy"
              :data-hash="card.hash"
              @click="setZIndex(card.hash)"
              @contextmenu.prevent="$refs.menu.open($event, card.hash)"
            >
              <vx-card
                :title="card.payload.title || 'Orders'"
                :editTitle="
                  $store.state.dashboardAnalytics.viewMode === 'edit'
                    ? true
                    : false
                "
              >
                <div slot="no-body" class="mt-4">
                  <vs-table
                    :data="card.payload.data"
                    class="table-dark-inverted"
                  >
                    <template slot="thead">
                      <vs-th
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        :style="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? { cursor: 'text' }
                            : { cursor: 'default' }
                        "
                        >{{ card.payload.columns.titleColumnOne || "" }}</vs-th
                      >
                      <vs-th
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        :style="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? { cursor: 'text' }
                            : { cursor: 'default' }
                        "
                        >{{ card.payload.columns.titleColumnTwo || "" }}</vs-th
                      >
                      <vs-th
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        :style="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? { cursor: 'text' }
                            : { cursor: 'default' }
                        "
                        >{{
                          card.payload.columns.titleColumnThree || ""
                        }}</vs-th
                      >
                      <vs-th
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        :style="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? { cursor: 'text' }
                            : { cursor: 'default' }
                        "
                        >{{ card.payload.columns.titleColumnFour || "" }}</vs-th
                      >
                      <vs-th
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        :style="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? { cursor: 'text' }
                            : { cursor: 'default' }
                        "
                        >{{ card.payload.columns.titleColumnFive || "" }}</vs-th
                      >
                      <vs-th
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        :style="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? { cursor: 'text' }
                            : { cursor: 'default' }
                        "
                        >{{ card.payload.columns.titleColumnSix || "" }}</vs-th
                      >
                      <vs-th
                        :contentEditable="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? true
                            : false
                        "
                        :style="
                          $store.state.dashboardAnalytics.viewMode === 'edit'
                            ? { cursor: 'text' }
                            : { cursor: 'default' }
                        "
                        >{{
                          card.payload.columns.titleColumnSeven || ""
                        }}</vs-th
                      >
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].columnOne">
                          <span>#{{ data[indextr].columnOne }}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].columnTwo">
                          <span class="flex items-center px-2 py-1 rounded"
                            ><div
                              class="h-3 w-3 rounded-full mr-2"
                              :class="'bg-' + data[indextr].columnTwoColor"
                            ></div>
                            {{ data[indextr].columnTwo }}</span
                          >
                        </vs-td>
                        <vs-td :data="data[indextr].columnOne">
                          <ul class="users-liked user-list">
                            <li
                              v-for="(user, userIndex) in data[indextr]
                                .columnThree"
                              :key="userIndex"
                            >
                              <vx-tooltip :text="user.name" position="bottom">
                                <vs-avatar
                                  :src="user.img"
                                  size="30px"
                                  class="border-2 border-white border-solid -m-1"
                                ></vs-avatar>
                              </vx-tooltip>
                            </li>
                          </ul>
                        </vs-td>
                        <vs-td :data="data[indextr].columnOne">
                          <span>{{ data[indextr].columnFour }}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].columnOne">
                          <span>{{ data[indextr].columnFive }}</span>
                          <vs-progress
                            :percent="data[indextr].columnFivePercent"
                            :color="data[indextr].columnTwoColor"
                          ></vs-progress>
                        </vs-td>
                        <vs-td :data="data[indextr].columnOne">
                          <span>{{ data[indextr].columnSix }}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].columnOne">
                          <span>{{ data[indextr].columnSeven }}</span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vx-card>
            </div>
          </vue-draggable-resizable>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import VueDraggableResizable from "vue-draggable-resizable";
import { VueContext } from "vue-context";
import vSelect from "vue-select";
import { performFetch } from '../helpers.js'

export default {
  dashboardRows: [],
  data() {
    return {
      timer: null,
      unsavedChanges: false,

      showWarningMessage: true,

      cardLabelData: [],

      minWidth: 0,
      mainDivKey: 0,
      draggableAndResizable: false,
      canLoadData: false,
      windowSize: window.innerWidth,
      dashboardData: {
        cardTypeOptions: [],
        showAddDashboardCardModal: false,
        screenSize: 0
      },
      screenParameters: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      dashboardDataEdit: {
        cardHash: "",
        cardName: "",
        cardType: {},
        cardDescription: "",
        showEditDashboardCardModal: false,
        cardWidth: 100,
        cardHeight: 100
      },
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      salesRadar: {},
      width: 0,
      height: 0,
      x: Number,
      y: Number,
      maxWidthCard: Number,
      rowsCount: Number,
      bodySize: String,
      totalScreenSize: Number,
      totalScreenHeight: Number,
      posicao: [],
      currentCopyCard: "",
      timelineData: [
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Client Meeting",
          desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
          time: "25 mins Ago"
        },
        {
          color: "warning",
          icon: "MailIcon",
          title: "Email Newsletter",
          desc: "Cupcake gummi bears soufflé caramels candy",
          time: "15 Days Ago"
        },
        {
          color: "danger",
          icon: "UsersIcon",
          title: "Plan Webinar",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 days ago"
        },
        {
          color: "success",
          icon: "LayoutIcon",
          title: "Launch Website",
          desc:
            "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.",
          time: "25 days ago"
        },
        {
          color: "primary",
          icon: "TvIcon",
          title: "Marketing",
          desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.",
          time: "28 days ago"
        }
      ],
      dispatchedOrders: [],
      typeOnRow: {
        1: 0,
        2: 0,
        3: 1,
        4: 1,
        5: 2,
        6: 2,
        7: 2,
        8: 3
      },
      dashboardCardsData: [],
      currentCardHashToDelete: "",
      maxZindex: 99999,
      currentItemToZindex: "",
      dashboardCardLabelData: {}
    };
  },
  components: {
    VueContext,
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
    VueDraggableResizable,
    vSelect
  },
  watch: {
    async "$route.params.dashboardHash"(value) {
      this.$vs.loading({ type: "default" });

      await this.getDashboardParameters();
      await this.getData();

      this.$vs.loading.close();
    },
    dashboardCardLabelData(value) {
      this.unsavedChanges = true;
      this.$store.commit("dashboardAnalytics/SET_LABEL_DATA", value);
    },
    "$store.state.dashboardAnalytics.viewMode"(value) {
      if (value === "view") {
        this.setViewMode();
      } else {
        this.setEditMode();
      }
    },
    "dashboardDataEdit.showEditDashboardCardModal"(value) {
      if (!value) {
        this.reloadCards();
      }
    },
    async "dashboardData.showAddDashboardCardModal"(value) {
      if (value) {
        this.$vs.loading({ type: "default" });
        await this.getDashboardParameters();
        this.$vs.loading.close();
      }
    },
    "$store.state.dashboardAnalytics.needReload"(value) {
      if (value) {
        this.getData();
      }
    },
    async "$store.state.dashboardAnalytics.mainDivKey"(value) {
      await this.getData(true);
    }
  },
  async created() {
    //  User Reward Card
    // console.log(JSON.stringify(response.data));
    // this.$http.get('/api/user/checkpoint-reward')
    //   .then((response) => { this.checkpointReward = response.data })
    //   .catch((error)   => { console.log(error) })

    //   // Subscribers gained - Statistics
    // this.$http.get('/api/card/card-statistics/subscribers')
    //   .then((response) => { this.subscribersGained = response.data })
    //   .catch((error)   => { console.log(error) })

    //   // Orders - Statistics
    // this.$http.get('/api/card/card-statistics/orders')
    //   .then((response) => { this.ordersRecevied = response.data })
    //   .catch((error)   => { console.log(error) })

    //   // Sales bar - Analytics
    // this.$http.get('/api/card/card-analytics/sales/bar')
    //   .then((response) => { this.salesBarSession = response.data })
    //   .catch((error)   => { console.log(error) })

    //   // Support Tracker
    // this.$http.get('/api/card/card-analytics/support-tracker')
    //   .then((response) => { console.log(response.data);this.supportTracker = response.data })
    //   .catch((error)   => { console.log(error) })

    //   // Products Order
    this.$http
      .get("/api/card/card-analytics/products-orders")
      .then(response => {
        this.productsOrder = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    //   // Sales Radar
    this.$http
      .get("/api/card/card-analytics/sales/radar")
      .then(response => {
        this.salesRadar = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    //   // Dispatched Orders
    // this.$http.get('/api/table/dispatched-orders')
    //   .then((response) => {
    //     this.dispatchedOrders = response.data
    //     console.log(JSON.stringify(this.dispatchedOrders))
    //   })
    //   .catch((error)   => { console.log(error) })

    window.addEventListener("resize", this.onResize);

    // console.log(JSON.stringify(this.analyticsData))
    // console.log(JSON.stringify(this.analyticsData.statisticsRadar.chartOptions))
  },
  async mounted() {
    let containerDashboard = document
      .getElementById("dashboard-analytics")
      .getBoundingClientRect();
    this.screenParameters.y = Math.round(containerDashboard.top);
    this.screenParameters.x = Math.round(containerDashboard.left);
    this.screenParameters.width = Math.round(containerDashboard.width);
    this.screenParameters.height = Math.round(containerDashboard.height);

    let dashboardWidth = document.querySelector("#dashboard-analytics");
    this.totalScreenSize = dashboardWidth.offsetWidth;
    let dashboardElement = dashboardWidth.getBoundingClientRect();
    this.totalScreenHeight = dashboardElement.height;
    this.$store.commit(
      "dashboardAnalytics/SET_DASHBOARD_SCREEN_SIZE",
      this.totalScreenSize
    );

    window.addEventListener("resize", () => {
      let newWidth = window.innerWidth;
      if (newWidth > 1366) {
        this.windowSize = window.innerWidth;
      }
    });

    this.$vs.loading({ type: "default" });

    await this.getDashboardParameters();
    await this.getData();

    this.$vs.loading.close();

    setTimeout(() => {
      this.setCardMax();
      this.setViewMode();
      this.vxrowWatcher();
    }, 300);

    // this.timer = setInterval(async () => {
    //   await this.getData()

    //   setTimeout(() => {
    //     this.setCardMax()
    //     this.setViewMode()
    //     this.vxrowWatcher()
    //   }, 300)
    // }, 10000)
  },
  methods: {
    fillLabelsObject(item) {
      this.$set(this.dashboardCardLabelData, item.hash, {});

      switch (item.type.id) {
        case 1:
          this.$set(
            this.dashboardCardLabelData[item.hash],
            1,
            item.payload.title
          );

          break;

        case 2:
          this.$set(
            this.dashboardCardLabelData[item.hash],
            2,
            item.payload.title
          );

          break;

        case 3:
          this.$set(
            this.dashboardCardLabelData[item.hash],
            3,
            item.payload.subtitle
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            4,
            item.payload.analyticsData.comparison.str
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            5,
            item.payload.viewDetailsButtonLabel
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            6,
            item.payload.bottomInfoOne.title
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            7,
            item.payload.bottomInfoTwo.title
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            8,
            item.payload.bottomInfoThree.title
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            9,
            item.payload.bottomInfoFour.title
          );

          break;

        case 4:
          this.$set(
            this.dashboardCardLabelData[item.hash],
            10,
            item.payload.title
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            11,
            item.payload.analyticsData["totalInfo"]
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            12,
            item.payload.analyticsData.meta[0]["label"]
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            13,
            item.payload.analyticsData.meta[1]["label"]
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            14,
            item.payload.analyticsData.meta[2]["label"]
          );

          break;

        case 5:
          this.$set(
            this.dashboardCardLabelData[item.hash],
            15,
            item.payload.title
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            16,
            item.payload.analyticsData
          );

          break;

        case 6:
          this.$set(
            this.dashboardCardLabelData[item.hash],
            17,
            item.payload.title
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            18,
            item.payload.subtitle
          );
          this.$set(
            this.dashboardCardLabelData[item.hash],
            19,
            item.payload.series
          );

          break;

        case 7:
          this.$set(
            this.dashboardCardLabelData[item.hash],
            20,
            item.payload.title
          );

          break;

        case 8:
          break;

        default:
          break;
      }

      this.$store.commit(
        "dashboardAnalytics/SET_LABEL_DATA",
        this.dashboardCardLabelData
      );
    },
    changeCardLabel(event, cardHash, labelType = null, index = null) {
      //

      if (event.hasOwnProperty("event") && event.hasOwnProperty("titleType")) {
        if (labelType === 20) {
          event = event.event;
        } else {
          // SALES STATS
          if (event.titleType === 1) {
            labelType = 17;
          } else {
            labelType = 18;
          }
          event = event.event;
        }
      }

      const newLabel = event.srcElement.innerText;

      if (index === null) {
        this.dashboardCardLabelData[cardHash][labelType] = newLabel;
      } else {
        if (labelType === 16) {
          this.dashboardCardLabelData[cardHash][labelType][index][
            "orderType"
          ] = newLabel;
        } else if (labelType === 19) {
          this.dashboardCardLabelData[cardHash][labelType][index][
            "name"
          ] = newLabel;
        }
      }
    },
    onResize() {
      this.windowSize = window.innerWidth;
    },
    vxrowWatcher() {
      this.rowsCount = 7;

      document.querySelectorAll(".dash-row").forEach(item => {
        if (item.innerHTML !== "") {
          this.rowsCount++;
        }
      });

      if (this.rowsCount <= 4) {
        this.bodySize = "min-height: calc(50vh - -103px)";
        // this.bodySize = 'min-height: calc(50vh - -290px)';
      }
      if (this.rowsCount >= 5) {
        this.bodySize = "min-height: calc(100vh - -103px)";
        // this.bodySize = 'min-height: calc(100vh - -290px)';
      }
      if (this.rowsCount >= 6) {
        this.bodySize = "min-height: calc(150vh - -103px)";
        // this.bodySize = 'min-height: calc(150vh - -290px)';
      }
      if (this.rowsCount > 6) {
        this.bodySize = "min-height: calc(150vh - -103px)";
        // this.bodySize = 'min-height: calc(150vh - -290px)';
      }
    },
    setCardMax() {
      if (this.windowSize > 900 && this.windowSize <= 1250) {
        let maxWidth = 900;
        this.maxWidthCard = maxWidth;
      }
      if (this.windowSize <= 900) {
        let maxWidth = 600;
        this.maxWidthCard = maxWidth;
      }
    },
    setViewMode() {
      const masterDiv = document.querySelector("#dashboard-analytics");
      masterDiv.style.border = "none";
      masterDiv.style.borderStyle = "none";
      this.draggableAndResizable = false;
      this.reloadCards();
    },
    setEditMode() {
      this.draggableAndResizable = true;
      setTimeout(() => {
        const masterDiv = document.querySelector("#dashboard-analytics");
        masterDiv.style.border = "2px solid #dae1e7";
        masterDiv.style.borderStyle = "dashed";
        this.reloadCards();
      }, 300);
    },
    viewDetailUrl(url) {
      // location.href =  url
      if (this.$store.state.dashboardAnalytics.viewMode === "view") {
        this.$router.push(url);
      } else {
        return;
      }
    },
    setZIndex(cardHash) {
      this.maxZindex++;
      document.querySelector(
        `[data-hash="${cardHash}"]`
      ).style.zIndex = this.maxZindex.toString();
    },
    onCopy(event) {
      const cardHash = event.target
        .closest("div.vx-col")
        .getAttribute("data-hash");

      if (typeof cardHash === "string") {
        this.currentCopyCard = cardHash;

        this.$vs.notify({
          title: "Operação Realizada!",
          text: "Card copiado para a área de transferência!",
          iconPack: "feather",
          icon: "icon-check",
          color: "success"
        });
      } else {
        this.$vs.notify({
          title: "Atenção!",
          text:
            "Não foi possível copiar o card. Selecione o card e tente novamente!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
      }
    },
    async onPaste(event, cardHash = null) {
      // this.$vs.loading({type: 'default'})

      if (cardHash === null) {
        if (this.currentCopyCard !== "") {
          let currentCardObject = {};

          this.$options.dashboardRows.forEach(rowItem => {
            if (Array.isArray(rowItem) && rowItem.length > 0) {
              rowItem.forEach(card => {
                if (card.hash === this.currentCopyCard) {
                  currentCardObject = JSON.parse(JSON.stringify(card));
                }
              });
            }
          });

          const cardName = currentCardObject.name;
          const cardDescription = currentCardObject.description;
          const cardWidth = currentCardObject.width;
          const cardHeight = currentCardObject.height;
          const cardTypeId = this.dashboardData.cardTypeOptions.find(
            x => x.id === currentCardObject.type_id
          ).id;

          await this.addDashboardCard(
            cardName,
            cardDescription,
            cardTypeId,
            cardWidth,
            cardHeight
          );

          this.$vs.loading.close();

          this.currentCopyCard = "";
        }
      } else {
        const currentCardObject = this.$store.state.dashboardAnalytics.cardsData.find(
          x => x.hash === cardHash
        );

        const cardName = currentCardObject.name;
        const cardDescription = currentCardObject.description;
        const cardWidth = currentCardObject.width;
        const cardHeight = currentCardObject.height;
        const cardTypeId = this.dashboardData.cardTypeOptions.find(
          x => x.id === currentCardObject.type_id
        ).id;

        await this.addDashboardCard(
          cardName,
          cardDescription,
          cardTypeId,
          cardWidth,
          cardHeight
        );

        this.$vs.loading.close();
      }
    },
    async addDashboardCard(
      cardName,
      cardDescription,
      cardTypeId,
      cardWidth = null,
      cardHeight = null
    ) {
      this.unsavedChanges = true;

      await this.updateDashboardLayout();

      this.$vs.loading({ type: "default" });

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "add_application_dashboard_card",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       card: {
      //         dashboard_hash: this.$route.params.dashboardHash,
      //         name: cardName,
      //         description: cardDescription,
      //         type_id: cardTypeId,
      //         width: cardWidth,
      //         height: cardHeight
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "add_application_dashboard_card",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            card: {
              dashboard_hash: this.$route.params.dashboardHash,
              name: cardName,
              description: cardDescription,
              type_id: cardTypeId,
              width: cardWidth,
              height: cardHeight
            }
          }
        })
        .then(async response => {
          if (response.status === 200) {
            this.$store.commit("dashboardAnalytics/SET_MAIN_DIV_KEY");

            this.dashboardData.showAddDashboardCardModal = false;

            this.$vs.loading.close();
            this.$vs.notify({
              title: "Operação realizada!",
              text: "Card adicionado com sucesso!",
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
          } else if (response.status === 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Atenção!",
            text: e.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    async updateDashboardLayout() {
      this.unsavedChanges = true;
      await this.$store.dispatch("dashboardAnalytics/updateDashboardLayout", {
        hash: this.$route.params.dashboardHash,
        data: this.$store.state.dashboardAnalytics.cardsData,
        screen_size: this.totalScreenSize
      });
    },
    async getDashboardParameters() {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_dashboard_parameters",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "get_application_dashboard_parameters",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
        .then(async response => {
          if (response.status === 200) {
            response.json().then(responseData => {
              setTimeout(() => {
                responseData.parameters.cards.forEach(item => {
                  const cardObject = {
                    id: item.id,
                    name: item.name
                  };

                  this.dashboardData.cardTypeOptions.push(cardObject);
                });
              }, 300);
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();

            // this.$vs.notify({
            //   title: 'Operação não realizada!',
            //   text: 'Ocorreu um erro ao carregar os parâmetros da tela',
            //   iconPack: 'feather',
            //   icon: 'icon-alert-circle',
            //   color: 'danger'
            // })
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Operação não realizada!",
            text: e.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    async updateCard() {
      this.$vs.loading({ type: "default" });
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "update_application_dashboard_card",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       card: {
      //         hash: this.dashboardDataEdit.hash,
      //         name: this.dashboardDataEdit.cardName,
      //         description: this.dashboardDataEdit.cardDescription
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "update_application_dashboard_card",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            card: {
              hash: this.dashboardDataEdit.hash,
              name: this.dashboardDataEdit.cardName,
              description: this.dashboardDataEdit.cardDescription
            }
          }
        })
        .then(async response => {
          if (response.status === 200) {
            this.dashboardDataEdit.showEditDashboardCardModal = false;

            this.$vs.notify({
              title: "Operação realizada!",
              text: "Card atualizado com sucesso!",
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });

            this.$store.commit("dashboardAnalytics/SET_MAIN_DIV_KEY");

            this.$vs.loading.close();
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();

            // this.$vs.notify({
            //   title: 'Operação não realizada!',
            //   text: 'Ocorreu um erro ao carregar os parâmetros da tela',
            //   iconPack: 'feather',
            //   icon: 'icon-alert-circle',
            //   color: 'danger'
            // })
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Operação não realizada!",
            text: e.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    confirmDeleteCard(cardHash) {
      this.currentCardHashToDelete = cardHash;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirmar Exclusão",
        text: "Você tem certeza que deseja excluir este card ?",
        accept: this.deleteCard,
        acceptText: "Excluir"
      });
    },
    async getCardDetail(cardHash) {
      this.$vs.loading({ type: "default" });

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_dashboard_card_detail",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       card_hash: cardHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "get_application_dashboard_card_detail",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            card_hash: cardHash
          }
        })
        .then(async response => {
          if (response.status === 200) {
            await response.json().then(responseData => {
              this.dashboardDataEdit.hash = responseData.card.hash;
              this.dashboardDataEdit.cardName = responseData.card.name;
              this.dashboardDataEdit.cardDescription =
                responseData.card.description;
              this.dashboardDataEdit.cardType = this.dashboardData.cardTypeOptions.find(
                x => x.id === responseData.card.type.id
              );

              this.dashboardDataEdit.showEditDashboardCardModal = true;
              this.$vs.loading.close();
            });
          } else if (response.status === 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          }
        })
        .catch(e => {
          console.log(e);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Atenção!",
            text: e.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    async deleteCard() {
      await this.updateDashboardLayout();
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "delete_application_dashboard_card",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard_hash: this.$route.params.dashboardHash,
      //       card_hash: this.currentCardHashToDelete
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "delete_application_dashboard_card",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            dashboard_hash: this.$route.params.dashboardHash,
            card_hash: this.currentCardHashToDelete
          }
        })
        .then(async response => {
          if (response.status === 200) {
            let findIndex = -1;
            let rowKeyToDelete = -1;

            this.$options.dashboardRows.forEach((rowItem, rowKey) => {
              if (findIndex === -1) {
                findIndex = rowItem.findIndex(
                  x => x.hash === this.currentCardHashToDelete
                );
                rowKeyToDelete = rowKey;
              }
            });

            if (findIndex > -1) {
              this.$options.dashboardRows[rowKeyToDelete].splice(findIndex, 1);
            }

            this.$store.commit("dashboardAnalytics/SET_MAIN_DIV_KEY");
            this.currentCardHashToDelete = "";
            this.$vs.notify({
              title: "Operação Realizada!",
              text: "Card Excluído com sucesso!",
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
            await this.getData();
          } else if (response.status === 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          }
        })
        .catch(e => {
          console.log(e);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Atenção!",
            text: e.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    reloadCards() {
      setTimeout(() => {
        document.querySelectorAll(".is-congrats").forEach(item => {
          item
            .querySelector(".vx-card__body")
            .classList.add("bg-primary-gradient");
          item.querySelector(".vx-card__body").style.borderRadius = "6px";
          this.minWidth = 217;
        });

        this.$vs.loading.close();
      }, 300);
    },
    optionClicked(text) {},
    async getData(rebuild = false) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_dashboard_data",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard_hash:
      //         this.$route.params.dashboardHash ||
      //         "7a935b22-967b-4952-9c3a-6e81477618a3"
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "get_dashboard_data",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            dashboard_hash:
              this.$route.params.dashboardHash ||
              "7a935b22-967b-4952-9c3a-6e81477618a3"
          }
        })
        .then(response => {
          if (response.status === 200) {
            response
              .json()
              .then(responseData => {
                this.$store.commit("dashboardAnalytics/SET_NEED_RELOAD", false);

                this.dashboardData.screenSize = responseData.screen_size;

                this.$options.dashboardRows = [[], [], [], []];

                let dashboardData = [];

                responseData.data.forEach(item => {
                  let x = item.x;

                  this.fillLabelsObject(item);

                  if (item.type.id === 5) {
                    item.payload.chartOptions.plotOptions.radialBar.dataLabels.total[
                      "formatter"
                    ] = function(v) {
                      let sum = 0;
                      item.payload.analyticsData.forEach(value => {
                        sum += value["counts"];
                      });
                      return sum;
                    };
                  }

                  this.$options.dashboardRows[
                    this.typeOnRow[item.type.id]
                  ].push({
                    hash: item.hash,
                    type_id: item.type.id,
                    width: item.width,
                    height: item.height,
                    index: item.index,
                    x: x,
                    y: item.y,
                    payload: item.payload
                  });

                  dashboardData.push({
                    hash: item.hash,
                    type_id: item.type.id,
                    type_name: item.type.name,
                    name: item.name,
                    description: item.description,
                    width: item.width,
                    height: item.height,
                    index: item.index,
                    x: x,
                    y: item.y,
                    payload: item.payload
                  });
                });

                this.$store.commit(
                  "dashboardAnalytics/SET_CARDS_DATA",
                  dashboardData
                );

                // if(this.currentItemToZindex) {
                //   setTimeout(() => {
                //     this.maxZindex ++
                //     document.querySelector(`[data-hash="${this.currentItemToZindex}"]`).style.zIndex = this.maxZindex.toString()
                //   }, 300)
                // }

                this.reloadCards();

                if (rebuild) {
                  this.mainDivKey = Math.random();
                }

                setTimeout(() => {
                  this.canLoadData = true;
                });
              })
              .catch(e => {
                console.log(e);
                // this.$vs.notify({
                //   title: 'Atenção!',
                //   text: e.message,
                //   iconPack: 'feather',
                //   icon: 'icon-alert-circle',
                //   color: 'danger'
                // })
                // throw new Error(e.message)
              });
          } else if (response.status === 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          }
        })
        .catch(e => {
          console.log(e);
          // this.$vs.notify({
          //   title: 'Atenção!',
          //   text: e.message,
          //   iconPack: 'feather',
          //   icon: 'icon-alert-circle',
          //   color: 'danger'
          // })
          // throw new Error(e.message)
        });
    },
    getItemAbove(currentItem) {
      const closestItems = [];

      this.$options.dashboardRows.forEach(row => {
        const filteredItems = row.filter(x => x.x < currentItem.x);

        filteredItems.forEach(filteredItem => {
          closestItems.push(filteredItem);
        });
      });

      let closestItem = closestItems.filter(
        x => x.x - currentItem.x < 100 && x.x - currentItem.x > -100
      );

      if (closestItem.length > 1) {
        closestItem = closestItem.reduce(function(prev, curr) {
          return prev.x > curr.x ? prev : curr;
        });
      } else {
        let closestItem = closestItems.filter(
          x => x.x - currentItem.x < 200 && x.x - currentItem.x > -200
        );

        if (closestItem.length > 1) {
          closestItem = closestItem.reduce(function(prev, curr) {
            return prev.x > curr.x ? prev : curr;
          });
        }
      }

      if (Array.isArray(closestItem) && closestItem.length > 0) {
        closestItem = closestItem[0];
      }

      if (Array.isArray(closestItem) && closestItem.length === 0) {
        closestItem = null;
      }

      return closestItem;
    },
    alignLeft(event, cardHash) {
      const currentCard = this.$store.state.dashboardAnalytics.cardsData.find(
        x => x.hash === cardHash
      );
      const closestItem = this.getItemAbove(currentCard);

      if (closestItem) {
        this.$options.dashboardRows = JSON.parse(
          JSON.stringify(this.$options.dashboardRows)
        );
        this.$options.dashboardRows.forEach((dashboardRow, dashboardIndex) => {
          dashboardRow.forEach((item, rowIndex) => {
            if (item.hash === cardHash) {
              this.$options.dashboardRows[dashboardIndex][rowIndex].x = 0;
              this.$options.dashboardRows[dashboardIndex][rowIndex].x =
                closestItem.x;

              this.$store.commit("dashboardAnalytics/SET_CARD_DATA", {
                hash: cardHash,
                data: this.$options.dashboardRows[dashboardIndex][rowIndex]
              });
            }
          });
        });
        this.reloadCards();
        this.mainDivKey = Math.random();
      } else {
        this.$vs.notify({
          title: "Dica!",
          text:
            "Se o alinhamento não estiver funcionando, tente aproximar mais os cards!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "primary"
        });
      }
    },
    getClosestItem(currentItem) {
      const closestItems = [];

      this.$options.dashboardRows.forEach(row => {
        const filteredItems = row.filter(x => x.x < currentItem.x);

        filteredItems.forEach(filteredItem => {
          closestItems.push(filteredItem);
        });
      });

      let closestItem = closestItems.filter(
        x => x.y - currentItem.y < 200 && x.y - currentItem.y > -200
      );

      if (closestItem.length > 1) {
        closestItem = closestItem.reduce(function(prev, curr) {
          return prev.x > curr.x ? prev : curr;
        });
      } else {
        // get any close

        let closestItem = closestItems.filter(
          x => x.y - currentItem.y < 200 && x.y - currentItem.y > -200
        );

        if (closestItem.length > 1) {
          closestItem = closestItem.reduce(function(prev, curr) {
            return prev.x > curr.x ? prev : curr;
          });
        }
      }

      if (Array.isArray(closestItem) && closestItem.length > 0) {
        closestItem = closestItem[0];
      }

      if (Array.isArray(closestItem) && closestItem.length === 0) {
        closestItem = null;
      }

      return closestItem;
    },
    alignItem(event, cardHash) {
      const currentCard = this.$store.state.dashboardAnalytics.cardsData.find(
        x => x.hash === cardHash
      );
      const closestItem = this.getClosestItem(currentCard);

      if (
        closestItem &&
        closestItem.hasOwnProperty("y") &&
        closestItem["y"] !== null
      ) {
        this.$options.dashboardRows = JSON.parse(
          JSON.stringify(this.$options.dashboardRows)
        );
        this.$options.dashboardRows.forEach((dashboardRow, dashboardIndex) => {
          dashboardRow.forEach((item, rowIndex) => {
            if (item.hash === cardHash) {
              this.$options.dashboardRows[dashboardIndex][rowIndex].y = 0;
              this.$options.dashboardRows[dashboardIndex][rowIndex].y =
                closestItem.y;

              this.$store.commit("dashboardAnalytics/SET_CARD_DATA", {
                hash: cardHash,
                data: this.$options.dashboardRows[dashboardIndex][rowIndex]
              });
            }
          });
        });
        this.reloadCards();
        this.mainDivKey = Math.random();
      } else {
        this.$vs.notify({
          title: "Dica!",
          text:
            "Se o alinhamento não estiver funcionando, tente aproximar mais os cards!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "primary"
        });
      }
    },
    quickFormatItem(event, cardHash) {
      const currentCard = this.$store.state.dashboardAnalytics.cardsData.find(
        x => x.hash === cardHash
      );
      const closestItem = this.getClosestItem(currentCard);

      if (closestItem) {
        this.$options.dashboardRows = JSON.parse(
          JSON.stringify(this.$options.dashboardRows)
        );
        this.$options.dashboardRows.forEach((dashboardRow, dashboardIndex) => {
          dashboardRow.forEach((item, rowIndex) => {
            if (item.hash === cardHash) {
              this.$options.dashboardRows[dashboardIndex][rowIndex].width = 0;
              this.$options.dashboardRows[dashboardIndex][rowIndex].height = 0;
              this.$options.dashboardRows[dashboardIndex][rowIndex].width =
                closestItem.width;
              this.$options.dashboardRows[dashboardIndex][rowIndex].height =
                closestItem.height;

              this.$store.commit("dashboardAnalytics/SET_CARD_DATA", {
                hash: cardHash,
                data: this.$options.dashboardRows[dashboardIndex][rowIndex]
              });
            }
          });
        });
        this.reloadCards();
        this.mainDivKey = Math.random();
      }
    },
    resizePosition(cardHash, x, y, width, height) {
      this.unsavedChanges = true;

      const currentCard = JSON.parse(
        JSON.stringify(
          this.$store.state.dashboardAnalytics.cardsData.find(
            x => x.hash === cardHash
          )
        )
      );

      currentCard["x"] = x;
      currentCard["y"] = y;
      currentCard["width"] = width;
      currentCard["height"] = height;

      this.$options.dashboardRows = JSON.parse(
        JSON.stringify(this.$options.dashboardRows)
      );

      this.$options.dashboardRows.forEach((dashboardRow, rowIndex) => {
        dashboardRow.forEach((item, cardIndex) => {
          if (item.hash === cardHash) {
            this.$options.dashboardRows[rowIndex][cardIndex].width = 0;
            this.$options.dashboardRows[rowIndex][cardIndex].height = 0;
            this.$options.dashboardRows[rowIndex][cardIndex].x = 0;
            this.$options.dashboardRows[rowIndex][cardIndex].y = 0;

            this.$options.dashboardRows[rowIndex][cardIndex].width = width;
            this.$options.dashboardRows[rowIndex][cardIndex].height = height;
            this.$options.dashboardRows[rowIndex][cardIndex].x = x;
            this.$options.dashboardRows[rowIndex][cardIndex].y = y;
          }
        });
      });

      this.reloadCards();

      this.$store.commit("dashboardAnalytics/SET_CARD_DATA", {
        hash: cardHash,
        data: currentCard
      });
    },
    dragPosition(cardHash, x, y) {
      this.unsavedChanges = true;

      let negativeAxle = false;

      const currentCard = JSON.parse(
        JSON.stringify(
          this.$store.state.dashboardAnalytics.cardsData.find(
            item => item.hash === cardHash
          )
        )
      );

      if (currentCard["x"] !== x || currentCard["y"] !== y) {
        if (x < 0) {
          x = 0;
          negativeAxle = true;
        }

        if (y < 0) {
          y = 0;
          negativeAxle = true;
        }

        if (!negativeAxle) {
          let sumWidth = parseInt(x) + parseInt(currentCard["width"]);
          let sumHeight = parseInt(y) + parseInt(currentCard["height"]);

          if (sumWidth > this.screenParameters.width) {
            x = this.screenParameters.width - currentCard["width"] - 30;
            negativeAxle = true;
          }

          if (y < 100) {
            if (sumHeight > this.screenParameters.height) {
              y = this.screenParameters.height - currentCard["height"] - 30;
              negativeAxle = true;
            }
          }
        }

        currentCard["x"] = x;
        currentCard["y"] = y;

        this.$options.dashboardRows = JSON.parse(
          JSON.stringify(this.$options.dashboardRows)
        );

        this.$options.dashboardRows.forEach((dashboardRow, rowIndex) => {
          dashboardRow.forEach((item, cardIndex) => {
            if (item.hash === cardHash) {
              this.$options.dashboardRows[rowIndex][cardIndex].x = 0;
              this.$options.dashboardRows[rowIndex][cardIndex].y = 0;
              this.$options.dashboardRows[rowIndex][cardIndex].x = x;
              this.$options.dashboardRows[rowIndex][cardIndex].y = y;
            }
          });
        });

        if (negativeAxle) {
          this.mainDivKey = Math.random();
        }

        this.reloadCards();

        this.$store.commit("dashboardAnalytics/SET_CARD_DATA", {
          hash: cardHash,
          data: currentCard
        });
      }
    }
  }
  // beforeRouteLeave (to, from, next) {
  //   // called when the route that renders this component has changed,
  //   // but this component is reused in the new route.
  //   // For example, for a route with dynamic params /foo/:id, when we
  //   // navigate between /foo/1 and /foo/2, the same Foo component instance
  //   // will be reused, and this hook will be called when that happens.
  //   // has access to >this component instance.

  //   clearInterval(this.timer)
  //   next()

  //   // if (this.unsavedChanges) {
  //   //   next()
  //   // } else {
  //   //   this.$vs.dialog({
  //   //     type: 'confirm',
  //   //     color: 'warning',
  //   //     title: 'Atenção',
  //   //     text: 'Você possui alterações que não foram salvas, você realmente deseja sair ? Essas alterações serão perdidas.',
  //   //     cancelText: 'Permanecer na página',
  //   //     accept: () => {
  //   //       next()
  //   //     },
  //   //     cancel: () => {
  //   //       next(false)
  //   //     },
  //   //     acceptText: 'Sair'
  //   //   })
  //   // }
  // },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
// svg {
//     width: 100%!important;
//     display: block;
//     height: auto;
//   }

.dashboard-container {
    width: 100% !important;
    position: relative;
    height: auto;
    min-height: calc(100vh - 103px);
    overflow: hidden;
    padding: 25px;
    // border-style: dashed!important;
    // border: 2px solid $grey-light;

  @media (max-width: 760px){
    max-height: 2780px;
  }
  @media (max-width: 680px){
    max-height: 3790px;
  }
}

#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
